import { Box, Typography } from '@material-ui/core';
import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import React from 'react';
import { CHECKOUT_SUN_URL } from 'settings';

import styles from './styles';

import type IProduct from 'interfaces/IProduct';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
  classes?: any;
}

export const CheckoutSunLink = ({ currentProduct, currentUserId, physicalProductPending, classes }: IProps) => {
  const isAffiliated = currentProduct.producer_id !== currentUserId;
  let urlCheckoutSun = `${CHECKOUT_SUN_URL}/${currentProduct.hash  ?? currentProduct.id}`;
  if (isAffiliated) {
    urlCheckoutSun += `?a=${currentUserId}`;
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.content}>
        <Typography className={classes.title}>Checkout Sun</Typography>
      </Box>

      <Box className={classes.inputContainer}>
        {!physicalProductPending && <CustomCopyToClipboard fullWidth disableUnderline text={urlCheckoutSun} />}
      </Box>
    </Box>
  );
};

export default styles(CheckoutSunLink);
